import styles from './styles.module.scss'

export function AddressFormWrapper({
  title,
  children
}: {
  title: string
  children: React.ReactNode
}) {
  return (
    <div className={styles.AccountForm}>
      <h4 className={styles.AccountForm__title}>{title}</h4>
      {children}
    </div>
  )
}
